import { useCallback, useMemo } from 'react';
import { useTranslation } from '@packlink/translation-provider';
import { IconNames } from '@shipengine/giger-theme';
import { Flag, FlagSize, FormElementGroup, SelectAutocomplete, Input, IconPopover, IconSize, Typography } from '@shipengine/giger';
import { getPhoneNumberPrefixStyles, getTooltipIconStyles } from './PhoneNumberStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const DROPDOWN_WIDTH = 250;
const PhoneNumber = _ref => {
  let {
    prefixOptions,
    value,
    disabled,
    isInvalid,
    cdnUrl,
    onChange,
    onBlur
  } = _ref;
  const {
    t
  } = useTranslation();
  const createFlag = useCallback(country => {
    return jsx(Flag, {
      country: country,
      size: FlagSize.SMALL,
      cdnUrl: cdnUrl
    });
  }, [cdnUrl]);
  const options = useMemo(() => prefixOptions.map(option => {
    return {
      ...option,
      leftContent: createFlag(option.alpha2Code)
    };
  }), [createFlag, prefixOptions]);
  const handlePrefixChange = (_name, prefix) => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      ...value,
      prefix: prefix !== null && prefix !== void 0 ? prefix : {
        alpha2Code: '',
        label: '',
        value: ''
      }
    });
  };
  const handleNumberChange = event => {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      ...value,
      number: event.target.value
    });
  };
  const handleOnBlur = () => {
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(value);
  };
  return jsxs(FormElementGroup, {
    children: [jsx(SelectAutocomplete, {
      css: getPhoneNumberPrefixStyles,
      name: "phone.prefix",
      noResultsLabel: t('invoice-form.search.no-results-prefix'),
      placeholder: t('invoice-form.label.phone-prefix'),
      value: value === null || value === void 0 ? void 0 : value.prefix,
      onChange: handlePrefixChange,
      onBlur: handleOnBlur,
      options: options,
      dropdownWidth: DROPDOWN_WIDTH,
      disabled: disabled,
      isInvalid: isInvalid
    }), jsx(Input, {
      label: t('invoice-form.label.phone-number'),
      name: "phone.number",
      onChange: handleNumberChange,
      onBlur: handleOnBlur,
      type: "number",
      value: value === null || value === void 0 ? void 0 : value.number,
      disabled: disabled,
      isInvalid: isInvalid,
      rightContent: jsx(IconPopover, {
        css: getTooltipIconStyles,
        icon: IconNames.INFO,
        size: IconSize.SIZE_MEDIUM,
        placement: "top-end",
        children: jsx(Typography, {
          variant: "body2",
          children: t('invoice-form.tooltip.phone-number')
        })
      })
    })]
  });
};
PhoneNumber.displayName = 'PhoneNumber';

export { PhoneNumber };
//# sourceMappingURL=PhoneNumber.js.map
